import { useEffect, useState } from "react";
import { listAll, list, ref, getDownloadURL } from 'firebase/storage';
import { firebaseStorage } from "../firebaseConfig";

const ImageList = () => {

    // const imageListRef = ref(firebaseStorage, "project_images/my_first_project/");
    const [imageUrlList, setImageUrlList] = useState([]);

    useEffect(() => {
        console.log('image list: ');
        // listAll(imageListRef).then((res) => {
        //     debugger;
        //     res.items.forEach((item) => {
        //         getDownloadURL(item).then((url) => {
        //             console.log("retreived url: " + url);
        //         });
        //     });
        // });
    });

    return (
        <div className="image-list">
            {
                imageUrlList.length > 0 && imageUrlList.forEach((url) => (
                    <h5>url</h5>
                ))
            }
        </div>
    );
}

export default ImageList;